import React from 'react';
import LoanForm from '../components/Loans/LoanForm';
import LoansTable from '../components/Loans/LoansTable';

const Loans = ({ items, onAddItem, onUpdateStatus, loading }) => {
  return (
    <div>
      <LoanForm onAddItem={onAddItem} />
      {loading ? <p>Carregando...</p> : (
        <LoansTable 
          items={items} 
          onUpdateStatus={onUpdateStatus} 
        />
      )}
    </div>
  );
};

export default Loans;